/* eslint-disable no-confusing-arrow */
import styled from 'styled-components'

export const DrawerBackdrop = styled.div`
  background-color: ${({ theme }) => theme.colors.black}70;

  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 10;

  transition: ${({ isOpen }) =>
    isOpen ? 'opacity 0.3s ease, visibility 0.3s ease' : 'opacity 0.3s ease 0.1s, visibility 0.3s ease 0.1s'};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
`
export const DrawerWrapper = styled.div`
  padding: 0;
  color: ${({ theme }) => theme.colors.primary};

  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 10px;

  position: fixed;
  top: 0;
  right: 0;

  transition: transform 0.2s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  z-index: 11; /* Above backdrop */
`
export const DrawerContainer = styled.div`
  height: 100%;
  padding: 0;
  margin: 10px;
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => `${theme.colors.secondary}80`};
  border-radius: 15px;
`
